import React from "react";
import { AppBar, Box, Button, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// Slide effect para sa full screen modal
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/** Full-screen catalogue details (phones / tablets). */
export default function LotDetailsModal({
  coa,
  exhibited,
  literature,
  openDetailsModal,
  provenance,
  setOpenDetailsModal,
  write_up,
}) {
  return (
    <Dialog
      fullScreen
      open={openDetailsModal}
      onClose={() => setOpenDetailsModal(false)}
      TransitionComponent={Transition}
      className="single-product-bell-mt"
    >
      <AppBar
        sx={{
          position: "sticky",
          top: 0,
          bgcolor: "#000",
          color: "#fff",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpenDetailsModal(false)}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{
              ml: 2,
              flex: 1,
              fontWeight: 800,
              fontSize: "13px",
              letterSpacing: "1px",
            }}
          >
            LOT DETAILS
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ p: 3, bgcolor: "#fff" }}>
        {[
          { label: "CERTIFICATE OF AUTHENTICITY", val: coa },
          { label: "PROVENANCE", val: provenance },
          { label: "EXHIBITED", val: exhibited },
          { label: "LITERATURE", val: literature },
          { label: "WRITE-UP", val: write_up },
        ].map(
          (item, idx) =>
            item.val && (
              <Box key={idx} sx={{ mb: 4 }}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 900,
                    color: "#999",
                    mb: 1,
                    textTransform: "uppercase",
                    borderBottom: "1px solid #eee",
                    letterSpacing: "1px",
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  component="div"
                  sx={{
                    fontSize: "1rem",
                    lineHeight: "1.8",
                    color: "#333",
                  }}
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.val.replace(/\n/g, "<br />"),
                    }}
                  ></p>
                </Typography>
              </Box>
            )
        )}
        <Button
          fullWidth
          variant="contained"
          onClick={() => setOpenDetailsModal(false)}
          sx={{
            mt: 2,
            mb: 5,
            bgcolor: "#2f2e2e",
            color: "#fff",
            borderRadius: 0,
            py: 1.5,
            fontWeight: 800,
          }}
        >
          CLOSE
        </Button>
      </DialogContent>
    </Dialog>
  );
}
